/**
 * Public event poster URL. Cards use the 1/3-res `cardImageUrl` when present;
 * modal / detail / SEO keep the full `imageUrl`.
 *
 * @param {Record<string, unknown>|null|undefined} event
 * @param {{ variant?: 'card' | 'full' }} [opts]
 * @returns {string}
 */
export function getEventImageSrc(event, { variant = 'full' } = {}) {
  const full = event?.imageUrl || event?.imagePath || event?.imageData || '';
  if (variant === 'card') {
    return event?.cardImageUrl || full;
  }
  return full;
}
